/** @jsxImportSource @emotion/react */
'use memo'

import css from '@emotion/css/macro'
import React from 'react'
import colors from '@sportninja/common/constants/appColors'
import { paragraphSmall, weightRegular } from 'src/components/css'

interface RegistrationScopeFieldProps {
  /** Already Title-cased by the caller. */
  label: string
  children: React.ReactNode
}

/**
 * One labelled control on the Registration tab's scope row (Season, Section) —
 * the label above the control, the same treatment as the Statistics tab's
 * Season / Player Type row.
 */
const RegistrationScopeField: React.FC<RegistrationScopeFieldProps> = ({
  label,
  children,
}) => (
  <div css={fieldStyle}>
    <span css={labelStyle}>{label}</span>
    {children}
  </div>
)

export default RegistrationScopeField

// ---- styled ----
const fieldStyle = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
`

const labelStyle = css`
  ${paragraphSmall}
  ${weightRegular}
  color: ${colors.NEUTRAL_0};
`
